// src/environment/environment.dev.js
const environment = {
  API_URL: "https://halrayarmutt.com/api/",
  // API_URL: "http://192.168.0.4:9090/",
};

export default environment;